import { render } from "./WebDesign.vue?vue&type=template&id=aac84cb6&scoped=true"
import script from "./WebDesign.vue?vue&type=script&lang=js"
export * from "./WebDesign.vue?vue&type=script&lang=js"

import "./WebDesign.vue?vue&type=style&index=0&id=aac84cb6&scoped=true&lang=css"

import exportComponent from "G:\\BWD\\BWD-NEW-05-04-2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aac84cb6"]])

export default __exports__